<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="2" sm="1" class="my-1">
            <!-- <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </b-form-group> -->
          </b-col>

          <b-col
            cols="12"
            class="d-flex justify-content-end mb-2"
            style="position: relative; z-index: 1"
          >
            <!-- <b-button
              v-if="HasPermission(PermissionList.HRMS_Search)"
              variant="outline-danger"
              @click="clearFilters"
            >
              Clear Filters
            </b-button> -->
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="filteredEmployees"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <!-- {{ data }} -->
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    :to="{
                      name: 'payroll-view',
                      params: {
                        id: data.item.id,
                        allocationDate:  data.item.formattedDate   ,
                      },
                    }"
                    v-if="HasPermission(PermissionList.HRMS_View)"
                  >
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">View</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
          <b-form-group>
            Showing
            {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
            to
            {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }}
            of
            {{ totalRows > 0 ? totalRows : 0 }}
            entries
          </b-form-group>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BCardBody,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import DatePicker from "vue2-datepicker";

import "vue2-datepicker/index.css";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BCardBody,
    DatePicker,
  },
  data() {
    const currentDate = new Date();
    const options = { year: "numeric", month: "short" };
    const currentMonthYear = currentDate.toLocaleString("en-US", options);
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      filter: null,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterOn: ["firstName"],
      filters: {
        firstName: "",
        lastName: "",
        Amount: "",
        email: "",
      },
      fields: [
        { key: "firstName", label: "First Name", sortable: true },
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "nic", label: "NIC", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      status: [
        {
          1: "Pending",
          2: "Approved",
          3: "Declined",
          4: "Cancelled",
        },
        {
          1: "light-secondary",
          2: "light-success",
          3: "light-danger",
          4: "Secondary",
        },
      ],
      payrollListing: [],
      period: [],
      selected: currentMonthYear,
      deleteLoader: null,
    };
  },

  computed: {
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    ...mapGetters("allocationModule", {
      payroll: "payroll",
      loading: "loading",
    }),
getAllocationDate(date)
{
return moment(date).format('MMM YYYY');
},
    filteredEmployees() {
      if (!this.payrollListing.length) return [];

      let payrolls = [];

      this.payrollListing.forEach((item) => {
        // Check if an entry with the same allocationDate exists
        let existingPayroll = payrolls.find(
          (x) => x.allocationDate === item.allocationDate
        );

        if (!existingPayroll) {
          // If not found, create a new entry
          existingPayroll = {
            firstName: item.employees.firstName,
            lastName: item.employees.lastName,
            email: item.employees.email,
            nic: item.employees.nic,
            id: item.employeeId,
            amount: 0, // Initialize amount
            allocationDate:  item.allocationDate ,
            formattedDate:  moment(item.allocationDate).format("MMM YYYY") 
          };
          payrolls.push(existingPayroll);
        }

        // Update the amount
        existingPayroll.amount +=
          item.allocationType == 0 ? item.amount : item.amount * -1;
      });

      this.totalRows = payrolls.length;


      return payrolls;
    },
  },

  methods: {
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "removeEmployeeAction",
    ]),

    ...mapActions("allocationModule", [
      "getPayrollListAction",
      "postPayrollAction",
      "exportPayrollAction",
      "getEmployeePayrollAction",
    ]),


    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    formatName: (employee) => `${employee.firstName} ${employee.lastName}`,
    formatDate: (employee) =>
      new Date(employee.hireDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
  },

  async mounted() {
    Swal.fire({
      title: "Fetching Data...",
      text: "Please wait while payroll data is loading.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      console.log("userdata", userData.id);
      const response = await this.getEmployeePayrollAction({
        //allocationDate: this.selected,
        employeeId: userData.id,
      });
      // Set payroll data

      this.payrollListing = response;
      this.currentPage = 1;

      Swal.close();
    } catch (error) {
      console.error("Error fetching payroll:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch payroll data. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  },

  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },
};
</script>